// `parties` — the array of people involved in a report (arrendatario,
// propietario, corredor, técnico, etc). Stored as JSONB on `reports.parties`.
// See decision_jsonb_parties_signatures.md (founder decision, 2026-04-29).
//
// The engine exposes a baseline schema. Per-recipe role validation
// (required roles, ID document type per role) happens in invariants.ts at
// write time using the recipe's PartyRole list.
import { emailSchema, phoneSchema, rutSchema, slugSchema } from "@bitacorapro/shared";
import { z } from "zod";
// idDoc is recipe-driven: the recipe declares whether a given role uses RUT,
// passport, national_id, or no document at all. We store the raw string
// here; recipe-aware validation re-parses it through the right schema.
// `name` is optional at the schema layer. Whether a given role *requires*
// a name is a recipe policy enforced in invariants.ts (validateParties),
// keyed off PartyRole.nameRequired — the same pattern `idDoc` already
// follows. A blanket `.min(1)` here would force a name on every role in
// every vertical and silently defeat facility's stroke-only signers
// (ADR-0040); the recipe-aware check preserves residential's guarantee.
const partySchema = z.object({
    role: slugSchema,
    name: z.string().trim().max(255).optional(),
    idDoc: z.string().trim().min(1).max(64).optional(),
    email: emailSchema.optional(),
    phone: phoneSchema.optional(),
});
export const partiesSchema = z.array(partySchema);
// Re-exported for use in recipe-aware validators.
export const rutDocumentSchema = rutSchema;
//# sourceMappingURL=parties.js.map